import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import useReduxData from "../../../../Hooks/useReduxData";
import { RoleTitle } from "../../../../Context/constants";
import {
    LIST_CATEGORY,
    LIST_CATEGORY_PRODUCTS,
    LIST_PRODUCT_BATCHES,
    REQUEST_INVENTORY, LIST_PRODUCT_STRENGTH
} from "../../../Repository/SettingRepo";
import { SearchAbleSelectBox } from "../../../../Component/Inputs";
import useMuiCompontent from "../../../../Hooks/useMuiCompontent";
import { requestInventoryValidation } from "../../../../Context/Validation"
import { Errors } from '../../../../Component/Error'

const RequestInventory = ({ openModal, handleClosedModal, handleOpenModal }) => {
    const [loader, setLoader] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const { reduxData: userdata } = useReduxData("userDataRDX");
    const { CustomButton } = useMuiCompontent();

    const [strengthList, setStrengthList] = useState([]);
    const [selectedStrength, setSelectedStrength] = useState(null);

    // Fetch category list on mount
    // useEffect(() => {
    //     getCategoryList();
    // }, []);

    async function getCategoryList() {
        setLoader(true);
        const payload = {
            activeStatus: true,
            providerId:
                userdata.roleTitle === RoleTitle.STAFF ||
                    userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.providerId
                    : userdata?.userId,
            frontdeskId:
                userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.userId
                    : undefined,
            staffId:
                userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        };
        try {
            const response = await LIST_CATEGORY(payload);
            setCategoryList(response?.data || []);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setCategoryList([]);
        } finally {
            setLoader(false);
        }
    }

    async function getProductsList(selectedCategoryId) {
        setLoader(true);
        const payload = {
            activeStatus: true,
            providerId:
                userdata.roleTitle === RoleTitle.STAFF ||
                    userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.providerId
                    : userdata?.userId,
            frontdeskId:
                userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.userId
                    : undefined,
            staffId:
                userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            category: selectedCategoryId,
        };
        try {
            const response = await LIST_CATEGORY_PRODUCTS(payload);
            setProductList(response?.data || []);
            setCategoryId(selectedCategoryId);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setProductList([]);
        } finally {
            setLoader(false);
        }
    }

    async function fetchStrengthList(selectedProductName) {
        setLoader(true);
        const payload = {
            activeStatus: true,
            providerId:
                userdata.roleTitle === RoleTitle.STAFF ||
                    userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.providerId
                    : userdata?.userId,
            frontdeskId:
                userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.userId
                    : undefined,
            staffId:
                userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            category: categoryId,
            productName: selectedProductName,
        };
        try {
            const response = await LIST_PRODUCT_STRENGTH(payload);
            setStrengthList(response?.data || []);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setStrengthList([]);
        } finally {
            setLoader(false);
        }
    }

    async function getBatchesList(selectedProductName, strength) {
        setLoader(true);
        const payload = {
            activeStatus: true,
            providerId:
                userdata.roleTitle === RoleTitle.STAFF ||
                    userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.providerId
                    : userdata?.userId,
            frontdeskId:
                userdata?.roleTitle === RoleTitle?.FRONT_DESK
                    ? userdata?.userId
                    : undefined,
            staffId:
                userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            category: categoryId,
            productName: selectedProductName,
            strength: strength || undefined,
        };
        try {
            const response = await LIST_PRODUCT_BATCHES(payload);
            setBatchList(response?.data || []);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setBatchList([]);
        } finally {
            setLoader(false);
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            category: null,
            requestedQuantity: "",
            manufactureDate: "",
            expiryDate: "",
            productName: null,
            batchNumber: null,
            strength: null || undefined,
        },
        validationSchema: requestInventoryValidation,
        onSubmit: async (values) => {
            setLoader(true);
            const payload = {
                providerId:
                    userdata.roleTitle === RoleTitle.FRONT_DESK ||
                        userdata.roleTitle === RoleTitle.STAFF
                        ? userdata?.providerId
                        : userdata?.userId,
                frontdeskId:
                    userdata.roleTitle === RoleTitle.FRONT_DESK
                        ? userdata?.userId
                        : undefined,
                staffId:
                    userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
                roleTitle: userdata.roleTitle,

                category: Array.isArray(values.category) ? values.category[0]?.id || null : values.category?.id || null,
                productName: Array.isArray(values.productName) ? values.productName[0]?.productName || null : values.productName?.productName || null,
                batchNumber: Array.isArray(values.batchNumber) ? values.batchNumber[0]?.batchNumber || null : values.batchNumber?.batchNumber || null,
                strength: Array.isArray(values.strength) ? values.strength[0]?.strength || null : values.strength?.strength || null,

                requestedQuantity: values.requestedQuantity || null,
                manufactureDate: values.manufactureDate || null,
                expiryDate: values.expiryDate || null,
                totalQuantity: values.totalQuantity || null,
            };
            try {
                let response = await REQUEST_INVENTORY(payload);
                toast.success(response.message);
                handleClosedModal("requestInventory", true);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoader(false);
            }
        },
    });

    const calculateShelfLife = (expiryDate) => {
        if (!expiryDate) return "";
        const today = new Date();
        const exp = new Date(expiryDate);
        const diffTime = exp.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays >= 0 ? diffDays : 0; // avoid negative
    };

    useEffect(() => {
        if (openModal?.requestInventory) {
            getCategoryList();
            setSelectedBatch(null);
            formik.resetForm();
        }
    }, [openModal?.requestInventory]);


    return (
        <Modal
            size="lg"
            show={openModal?.requestInventory === true}

            onHide={() => handleClosedModal("requestInventory")}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Body>
                <div>
                    <p className="modal-title mb-0">
                        {`${openModal?.data ? "Update" : "Add"} Inventory Request`}
                    </p>
                </div>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit(e);
                    }}
                >

                    <div className="modal-body cus-i">
                        <div className="row">
                            {/* Category */}
                            <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                <div className="row">
                                    <div className="col-lg-9">
                                        <div className="row">
                                            <div className="col-lg-5 px-0">
                                                <label className="form-label mb-0">Category<span className='Star_Mark'>*</span></label>
                                            </div>
                                            <div className="col-lg-7">
                                                <SearchAbleSelectBox
                                                    multiple={false}
                                                    option={categoryList}
                                                    getOptionLabel="name"
                                                    isOptionEqualToValue="id"
                                                    value={formik.values.category}
                                                    name="category"
                                                    handalSearchAbleSelectBox={(event, newValue) => {
                                                        formik.setFieldValue("category", newValue || null);
                                                        console.log("Selected Category:", newValue);
                                                        const selected = Array.isArray(newValue) ? newValue[0] : newValue;
                                                        if (selected) {
                                                            getProductsList(selected.id);
                                                            formik.setFieldValue("productName", null);
                                                            formik.setFieldValue("batchNumber", null);
                                                            setProductList([]);
                                                            setBatchList([]);
                                                            setSelectedBatch(null);
                                                        }
                                                    }}

                                                />
                                                <Errors formikfun={formik} name={"category"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Product */}
                            <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                <div className="row">
                                    <div className="col-lg-9">
                                        <div className="row">
                                            <div className="col-lg-5 px-0">
                                                <label className="form-label mb-0">Product<span className='Star_Mark'>*</span></label>
                                            </div>
                                            <div className="col-lg-7">
                                                <SearchAbleSelectBox
                                                    multiple={false}
                                                    option={productList}
                                                    getOptionLabel="productName"
                                                    isOptionEqualToValue={(option, value) => option?.productName === value?.productName}
                                                    value={formik.values.productName}
                                                    name="productName"
                                                    handalSearchAbleSelectBox={(event, newValue) => {
                                                        const selected = Array.isArray(newValue) ? newValue[0] : newValue;
                                                        formik.setFieldValue("productName", newValue || null);

                                                        // Reset strength and batch
                                                        formik.setFieldValue("batchNumber", null);
                                                        setBatchList([]);
                                                        setSelectedBatch(null);
                                                        setSelectedStrength(null);
                                                        setStrengthList([]);

                                                        if (selected) {
                                                            // If category is Medicine, fetch strength list
                                                            if (formik.values.category[0]?.name === "Medicine") {
                                                                fetchStrengthList(selected.productName);
                                                            } else {
                                                                getBatchesList(selected.productName); // Regular batch fetch
                                                            }
                                                        }
                                                    }}
                                                />
                                                <Errors formikfun={formik} name={"productName"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {formik.values.category && formik.values.category[0]?.name === "Medicine" && formik.values.productName && (
                                <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                    <div className="row">
                                        <div className="col-lg-9">
                                            <div className="row">
                                                <div className="col-lg-5 px-0">
                                                    <label className="form-label mb-0">Strength<span className='Star_Mark'>*</span></label>
                                                </div>
                                                <div className="col-lg-7">
                                                    <SearchAbleSelectBox
                                                        multiple={false}
                                                        option={strengthList}
                                                        getOptionLabel="strength"
                                                        isOptionEqualToValue={(option, value) => option?.strength === value?.strength}
                                                        value={formik.values.strength}
                                                        name="strength"
                                                        handalSearchAbleSelectBox={(event, newValue) => {
                                                            const selected = Array.isArray(newValue) ? newValue[0] : newValue;
                                                            formik.setFieldValue("strength", newValue || null);
                                                            // setSelectedStrength(selected);
                                                            formik.setFieldValue("batchNumber", null);
                                                            setBatchList([]);
                                                            setSelectedBatch(null);
                                                            if (selected) {
                                                                // Pass the selected product from product selection directly
                                                                getBatchesList(formik.values.productName?.productName || selected.productName, selected.strength);
                                                            }
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}

                            {/* Batch */}
                            <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                <div className="row">
                                    <div className="col-lg-9">
                                        <div className="row">
                                            <div className="col-lg-5 px-0">
                                                <label className="form-label mb-0">Batch<span className='Star_Mark'>*</span></label>
                                            </div>
                                            <div className="col-lg-7">
                                                <SearchAbleSelectBox
                                                    multiple={false}
                                                    option={batchList?.batches || []}
                                                    getOptionLabel="batchNumber"
                                                    isOptionEqualToValue={(option, value) => option?.batchNumber === value?.batchNumber}
                                                    value={formik.values.batchNumber}
                                                    name="batchNumber"
                                                    handalSearchAbleSelectBox={(event, newValue) => {
                                                        const selected = Array.isArray(newValue) ? newValue[0] : newValue;
                                                        console.log("22222222222222222", batchList)
                                                        formik.setFieldValue("batchNumber", newValue || null);
                                                        if (selected) {
                                                            setSelectedBatch(selected);
                                                            formik.setFieldValue("totalQuantity", batchList.totalQuantity || 0);
                                                            formik.setFieldValue("manufactureDate", selected.manufactureDate);
                                                            formik.setFieldValue("expiryDate", selected.expiryDate);
                                                        }
                                                    }}
                                                />
                                                <Errors formikfun={formik} name={"batchNumber"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Auto-filled fields */}
                            {selectedBatch && (
                                <>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <div className="row">
                                                    <div className="col-lg-5 px-0">
                                                        <label className="form-label mb-0">Total Quantity<span className='Star_Mark'>*</span></label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={formik.values.totalQuantity}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <div className="row">
                                                    <div className="col-lg-5 px-0">
                                                        <label className="form-label mb-0">Manufacture Date<span className='Star_Mark'>*</span></label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={formik.values.manufactureDate}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <div className="row">
                                                    <div className="col-lg-5 px-0">
                                                        <label className="form-label mb-0">Expiry Date<span className='Star_Mark'>*</span></label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={formik.values.expiryDate}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                        <div className="row">
                                            <div className="col-lg-9">
                                                <div className="row">
                                                    <div className="col-lg-5 px-0">
                                                        <label className="form-label mb-0">Shelf Life (days)<span className='Star_Mark'>*</span></label>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={calculateShelfLife(formik.values.expiryDate)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )}
                            <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                                <div className="row">
                                    <div className="col-lg-9">
                                        <div className="row">
                                            <div className="col-lg-5 px-0">
                                                <label className="form-label mb-0">Quantity<span className='Star_Mark'>*</span></label>
                                            </div>
                                            <div className="col-lg-7">
                                                <input
                                                    type="number"
                                                    name="requestedQuantity"
                                                    className="form-control"
                                                    value={formik.values.requestedQuantity}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Enter quantity"

                                                />
                                                <Errors formikfun={formik} name={"requestedQuantity"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-end mt-3 pe-1">
                        <CustomButton
                            variant="outlined"
                            className="mui_button_color me-2"
                            onClick={() => {
                                formik.resetForm();
                                handleClosedModal("requestInventory");
                                setCategoryList([]);
                                setProductList([]);
                                setBatchList([]);
                                setCategoryId(null);
                                setSelectedBatch(null);
                            }}
                        >
                            Cancel
                        </CustomButton>
                        <button
                            type="submit"
                            style={{
                                width: "64px",
                                height: "32.75px",
                                textTransform: "capitalize",
                                transition: "box-shadow 0.3s",
                                fontSize: "15px",
                                backgroundColor: "#38C4B9",
                                padding: "5px 8px",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.boxShadow =
                                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)";
                                e.currentTarget.style.backgroundColor = "#38C4B9";
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            {openModal?.data ? "Update" : "Save"}
                        </button>

                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default RequestInventory;
